import { useHistory } from "react-router-dom";

const useCheckHistory = () => {
  const history = useHistory();

  const goBackOrRedirect = (redirectPath: string) => {
    if (history.length > 1) history.goBack();
    else history.push(redirectPath);
  };

  return goBackOrRedirect;
};

export default useCheckHistory;
